import { render, staticRenderFns } from "./VOffline.vue?vue&type=template&id=70228aca&scoped=true"
import script from "./VOffline.vue?vue&type=script&lang=js"
export * from "./VOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70228aca",
  null
  
)

export default component.exports